/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { ModalBody as ChakraModalBody, ModalBodyProps } from '@chakra-ui/react'
import React from 'react'

import * as styles from './styles'

interface Props extends ModalBodyProps {}

export const ModalBody = ({ css, ...rest }: Props) => {
  return <ChakraModalBody css={[styles.body, css]} {...rest} />
}
